
import React, { memo } from 'react';
import { withStyles } from 'tss-react/mui';
import { Grid, Box, Typography, CircularProgress } from '@mui/material';

const styles = theme => ({
    loadingOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1,
    }
});

const PresetLoader = memo(({ classes }) => (
    <Box className={classes.loadingOverlay}>
        <Grid
            container
            direction='column'
            alignItems='center'
            justifyContent='center'
            style={{ height: '100%', maxWidth: '100%' }}
            spacing={2}
        >
            <Grid>
                <Typography variant='h5'>
                    Loading presets...
                </Typography>
            </Grid>
            <Grid>
                <CircularProgress size={80} />
            </Grid>
        </Grid>
    </Box>
));

export default withStyles(PresetLoader, styles);